import settings from '../settings.js'

const $inject = ['$http', 'UserService']

function ArticleService(http, UserService) {
    this.getSomeFeed = function(callback) {
        let url = '?controller=ajax&somefeed=1'+settings.someFeedArgs;

        if (settings.someFeedId) {
            const _callback = callback;
            url = '?controller=ajax&socialfeed=pull&feedupdate=1&feedid='+settings.someFeedId;
            callback = function(data) {
                let feed = data.feed && data.feed.moderated ? data.feed.moderated : [];
                _callback(feed);
            };
        }

        http({
            method: 'GET',
            url: settings.baseUrl+url+getQueryString()
        }).success(callback);
    };
    
    this.getNewsArticle = function(articleId, callback) {
        const url = '?controller=ajax&appmode=1&method=article&lang=' + UserService.langCode + '&articleid='+articleId;

        http({
            method: 'GET',
            url: settings.baseUrl+url+getQueryString()
        }).success(callback);
    };

    this.getNewsFeed = (articleSettings) => {
        let url = settings.baseUrl+'?controller=ajax&appmode=1&method=getLastItems&lang=' + UserService.langCode;

        if (articleSettings) {
            if (articleSettings.category)
                url += '&categoryName=' + articleSettings.category;

            if (articleSettings.page)
                url += '&page=' + articleSettings.page;

            if (articleSettings.perPage)
                url += '&per_page=' + articleSettings.perPage;
        }

        url += getQueryString();

        return http({
            method: 'GET',
            url: url
        });
    };

    this.newsLookup = (category, callback) => {
        http({
            method: 'GET',
            url: settings.bareUrl+'?newslookup='+category+getQueryString()
        }).success(callback);
    };

    this.getArticleSurvey = (hash, callback) => {
        let url = '?action=getarticlesurvey&lang=' + UserService.langCode + '&hash=';

        if (typeof hash === 'number')
            url = '?action=getarticlesurvey&surveyid=';

        return http({
            method: 'GET',
            url: settings.baseUrl+url+hash+getQueryString()
        });
    };

    function getQueryString() {
        return '&nocache='+Date.now()+'&appauth='+settings.appAuthSecret;
    }
}

ArticleService.$inject = $inject

export default ArticleService